/**
 * Checks if any item in the given array has been modified or rejected.
 *
 * @param {DeliveryForecastItemSplit[]} items - An array of DeliveryForecastItemSplit objects.
 * @returns {boolean} Returns true if any item has a status of 'MODIFIED' or 'REJECTED', otherwise returns false.
 *
 * @example
 * const items = [{ Status: 'MODIFIED' }, { Status: 'ACCEPTED' }];
 * console.log(areItemplitsModified(items)); // Output: true
 */
import { DeliveryForecastItemSplit } from '../../../data/models'

export function areItemSplitsModified(
  items: DeliveryForecastItemSplit[],
): boolean {
  const isModified = items?.find(
    (item: DeliveryForecastItemSplit) =>
      item.Status === 'MODIFIED' || item.Status === 'REJECTED',
  )

  return isModified ? true : false
}
